import {
  DocumentTrashListSchema,
  DocumentTrashRequestSchema,
  DocumentTrashResultSchema,
  type DocumentTrashSource,
} from "../../shared/document-trash";
import { parseResponse } from "../api/client-core";

const root = (slug?: string) =>
  slug ? `/api/ops/customers/${encodeURIComponent(slug)}` : "/api/ops/docs";
const post = (body: unknown = {}) => ({
  method: "POST",
  credentials: "same-origin" as const,
  headers: { "Content-Type": "application/json" },
  body: JSON.stringify(body),
});
export async function listDeletedDocuments(slug?: string, cursor?: string) {
  return parseResponse(
    await fetch(
      `${root(slug)}/recycle-bin${cursor ? `?cursor=${encodeURIComponent(cursor)}` : ""}`,
      { credentials: "same-origin" },
    ),
    DocumentTrashListSchema,
  );
}
export async function deleteDocument(input: {
  slug?: string | undefined;
  source: DocumentTrashSource;
  id: string;
  revision: number;
}) {
  const path =
    input.source === "internal"
      ? `/pages/${encodeURIComponent(input.id)}/trash`
      : `/document-trash/${input.source}/${encodeURIComponent(input.id)}`;
  return parseResponse(
    await fetch(
      `${root(input.slug)}${path}`,
      post(DocumentTrashRequestSchema.parse({ expectedRevision: input.revision })),
    ),
    DocumentTrashResultSchema,
  );
}
export async function recoverDocument(id: string, slug?: string) {
  return parseResponse(
    await fetch(`${root(slug)}/recycle-bin/${encodeURIComponent(id)}/restore`, post()),
    DocumentTrashResultSchema,
  );
}
